import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, Action } from 'redux'
import { createStructuredSelector } from 'reselect'
import { transferCodeSelector } from '@/checkout-instore-legacy/transfer/selectors'
import { isCustomerAnonymousNameSelector } from '@/checkout-instore-legacy/customer/selectors'

import { actionCreators } from '../actions'

import SocialShare from '../components/SocialShare'

const mapStateToPropsSelector = createStructuredSelector({
  shareCode: transferCodeSelector,
  isCustomerAnonymousNameSelector,
})

const mapDispatchToProps = (dispatch: Dispatch<Action>) =>
  bindActionCreators(actionCreators, dispatch)

// @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
export default connect(mapStateToPropsSelector, mapDispatchToProps)(SocialShare)
